import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import $ from 'jquery';

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        $('#content-container').scrollTop(0);
    }, [pathname]);

    return null;
}